<template>
    <div class="vx-card p-6">
        <div class="vx-row mb-4">
            <div class="vx-col w-full">
                <h3>Thông tin sự kiện, tin tức</h3>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col md:w-2/3 w-full">
                <div class="vx-row">
                    <!-- branch-->
                    <div class="vx-col w-full">
                        <label class="vs-input--label">Chi nhánh</label>
                        <v-select class="w-full" v-model="selectedOrganizationBranch"
                                  :options="organizationBranchOptions"
                                  :clearable="false" name="branch" v-validate="'required'">
                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('branch') }}</span>
                    </div>
                </div>
                <div class="vx-row">
                    <!--title-->
                    <div class="vx-col w-full mt-4">
                        <label class="vs-input--label">{{ this.$t('menuNewsEvent.title') }}</label>
                        <span class="text-danger">*</span>
                        <vs-input class="w-full" v-model="dataNewEvent.title"
                                  :placeholder="$t('menuNewsEvent.enterTitle')"
                                  :disable="isUpdate" v-validate="'required'" name="title">
                        </vs-input>
                        <span class="text-danger text-sm">{{ errors.first('title') }}</span>
                    </div>
                </div>
                <!--type-->
                <div class="vx-row">
                    <div class="vx-col w-full mt-4">
                        <label class="vs-input--label">{{ this.$t('menuNewsEvent.type') }}</label>
                        <span class="text-danger">*</span>
                        <v-select v-model="selectNews" :options="options" :clearable="false" v-validate="'required'"
                                  name="typeForNewsEvent">
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('typeForNewsEvent') }}</span>
                    </div>
                </div>
                <!--status-->
                <div class="vx-row">
                    <div class="vx-col md:w-1/2 w-full mt-4" v-if="isUpdate">
                        <label class="vs-input--label">{{ this.$t('menuNewsEvent.activePost') }}</label>
                        <vx-tooltip :text="$t('menuNewsEvent.onOff')">
                            <vs-switch class="mt-2" v-model="turnOnOff"/>
                        </vx-tooltip>
                    </div>
                </div>
            </div>
            <!--Images-->
            <div class="vx-col md:w-1/3 w-full flex flex-col justify-center md:mt-0 mt-6">
                <label class="vs-input--label m-auto">Ảnh mô tả tin tức</label>
                <vue-upload-multiple-image class="m-auto " @upload-success="uploadImageSuccess"
                                           @before-remove="beforeRemove" @data-change="dataChange"
                                           :data-images="images">
                </vue-upload-multiple-image>
            </div>
        </div>

        <!--contentPost-->
        <div class="vx-row mt-2 mb-3">
            <div class="vx-col w-full mt-4 quill-editor">
                <label class="vs-input--label">{{ this.$t('menuNewsEvent.contentPost') }}</label>
                <quill-editor v-model="dataNewEvent.content" class="input-content contentPost">
                </quill-editor>
            </div>
        </div>
        <br>
        <br>
        <!--buttons-->
        <div class="vx-row">
            <div class="vx-col w-full ">
                <div class="flex flex-wrap items-center justify-end">
                    <vs-button class="ml-auto mt-2 button" :disabled="!validateForm" @click="saveInfoNewEvent"
                               v-if="(isUpdate && isPermissionUpdateNewsEvent) || (!isUpdate && isPermissionCreateNewsEvent)">
                        {{ `${isUpdate ? $t('button.update') : $t('button.create')}` }}
                    </vs-button>
                    <vs-button class="ml-4 mt-2 button" type="border" color="warning" onclick="history.back()">
                        {{ $t('button.back') }}
                    </vs-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker';
import utils from "../../../../components/utils";
import moment from 'moment';
import 'quill/dist/quill.snow.css';
import {quillEditor} from 'vue-quill-editor'
import VueUploadMultipleImage from '../../../../components/VueUploadMultipleImage';
import authConfig from '@/../auth_config.json';
import {isAPI, isRouter} from "../../../../store/permission";
import {constAPI, constRouter} from "../../../../store/constant";

export default {
    components: {
        vSelect,
        Datepicker,
        utils,
        moment,
        quillEditor,
        VueUploadMultipleImage,
        authConfig,
    },
    data() {
        return {
            isUpdate: false,
            images: [],
            dataNewEvent: {
                title: null,
                content: null,
                type: null,
                organizationBranchId: null,
                activeStatus: null,
            },

            organizationBranchOptions: [],
            selectedOrganizationBranchValue: null,
            options: [
                {value: 1, label: "Tin tức"},
                {value: 2, label: "Sự kiện"},
                {value: 3, label: 'Tài liệu thẩm mỹ'},
                {value: 4, label: 'Khuyến mãi'},
            ],
            selectNewsValue: null,
            turnOnOff: true,
            fileListData: [],
        }
    },
    async created() {

        if (this.$route.query.id) {
            this.isUpdate = true;
            await this.findServiceById(this.$route.query.id);
            for (const x of this.dataNewEvent.fileManagers) {
                let data = await this.toDataURL(x.url);
                let dataImage = data.xhr.response;
                let metadata = {
                    type: 'image/jpeg'
                };
                let file = new File([dataImage], x.fileName, metadata);
                this.images.push({
                    name: x.fileName,
                    path: data.imgBase64,
                    highlight: 1,
                    default: 1,
                    file: file
                });
            }
        }
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        if (branchList.length === 0) {
            return this.$vs.notify({
                text: this.$t('menuOrganization.noBranch'),
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        }

        this.organizationBranchOptions = branchList.map(item => {
            return {value: item.id, label: item.organizationBranchName}
        });
        this.organizationBranchOptions.unshift({value: null, label: 'Tất cả'});
    },
    methods: {
        async saveInfoNewEvent(evt) {
            //Validate data
            evt.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;

            if (this.isUpdate) this.dataNewEvent.activeStatus = this.turnOnOff ? 1 : 0;

            let checkRatioImages = this.images.filter(x => x.ratio < 16 / 9);
            if (checkRatioImages.length > 0) {
                // this.images = this.images.filter(x => x.ratio >= 16 / 9);
                return this.$vs.notify({
                    color: 'danger',
                    text: 'Ảnh mô tả phải có tỷ lệ lớn hơn hoặc bằng 16:9!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
            }

            if (!this.images || this.images.length === 0) {
                return this.$vs.notify({
                    color: 'danger',
                    text: 'Ảnh mô tả là trường bắt buộc!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
            }

            // Xu ly du lieu formData
            let formData = new FormData();
            this.images.forEach(x => formData.append('files', x.file));
            const blob = new Blob([JSON.stringify(this.dataNewEvent)], {type: 'application/json'});
            formData.append('dto', blob);
            let url = this.isUpdate ? `/beauty-post/update` : `/beauty-post/create`;

            // Goi API
            this.$vs.loading();
            this.$crm.post(url, formData).then(() => {
                this.$vs.notify({
                    color: 'success',
                    text: `${this.isUpdate ? this.$t('menuNewsEvent.updateNewEventNotify') : this.$t('menuNewsEvent.addNewEventNotify')}`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                this.$vs.loading.close();
                return this.$router.push('/user/manage-news-event').catch(() => {});
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },

        organizationBranchString(id) {
            let organizationBranch = this.organizationBranchOptions.find(x => x.value === id);
            return (organizationBranch && organizationBranch.label) || this.$t('menuOrganization.null');
        },

        findServiceById(id) {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.get(`/beauty-post/find-by-id/${id}`).then(res => {
                    this.turnOnOff = res.data.activeStatus !== 0;
                    this.dataNewEvent = res.data;
                    resolve()
                    this.$vs.loading.close();
                }).catch(err => {
                    reject()
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },
        //Images
        async uploadImageSuccess(formData, index, fileList,) {
            this.images = fileList.map(element => {
                var reader = new FileReader();
                reader.onload = function (e) {
                    var img = new Image();
                    img.onload = function () {
                        var width = this.width;
                        var height = this.height;
                        var ratio = width / height;
                        element.ratio = ratio;
                    };
                    img.src = e.target.result;
                };
                reader.readAsDataURL(element.file);
                return element;
            });
            this.setIsUpdateImages();
        },
        beforeRemove(index, done, fileList) {
            this.setIsUpdateImages();
            done();
            this.images = fileList.map(element => {
                var reader = new FileReader();
                reader.onload = function (e) {
                    var img = new Image();
                    img.onload = function () {
                        var width = this.width;
                        var height = this.height;
                        var ratio = width / height;
                        element.ratio = ratio;
                    };
                    img.src = e.target.result;
                };
                reader.readAsDataURL(element.file);
                return element;
            });
        },
        // editImage(formData, index, fileList) {
        //     this.images = fileList;
        //     this.setIsUpdateImages();
        // },
        dataChange() {
            this.images = fileList;
            this.setIsUpdateImages();
        },
        setIsUpdateImages() {
            if (this.isUpdate) {
                this.isUpdateImages = true;
            }
        },
        toDataURL(url) {
            return new Promise(resolve => {
                let xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    let reader = new FileReader();
                    reader.onloadend = function () {
                        resolve({imgBase64: reader.result, xhr: xhr});
                    }
                    reader.readAsDataURL(xhr.response);
                };
                xhr.open('GET', url);
                xhr.responseType = 'blob';
                xhr.send();
            })
        },

        isPermissionCreateNewsEvent() {
            return isAPI(this, constAPI.beauty_post_create);
        },

        isPermissionUpdateNewsEvent() {
            return isAPI(this, constAPI.beauty_post_update);
        },
    },
    computed: {
        validateForm() {
            return !this.errors.any();
        },
        selectedOrganizationBranch: {
            get() {
                let object = this.organizationBranchOptions.find(el => el.value === this.dataNewEvent.organizationBranchId);
                if (!object) return;
                return {
                    label: object.label,
                    value: object.value
                }
            },
            set(obj) {
                this.dataNewEvent.organizationBranchId = obj ? obj.value : null;
            }
        },

        selectNews: {
            get() {
                let obj = this.options.find(x => x.value === this.dataNewEvent.type);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.dataNewEvent.type = obj ? obj.value : null;
            }
        }
    },
}
</script>
<style scoped>
@media (min-width: 320px) and (max-width: 399px) {
    .contentPost {
        margin-bottom: 125px;
        height: 200px;
    }

    .vs-input--label {
        justify-items: start !important;
        align-items: start !important;
        margin-top: 20px;
    }

    .button {
        margin-top: 10px !important;
    }
}

@media (min-width: 400px) and (max-width: 411px) {
    .contentPost {
        margin-bottom: 120px;
        height: 300px;
    }

    .vs-input--label {
        margin-top: 20px;
    }

    .button {
        margin-top: 10px !important;
    }

}

@media (min-width: 412px) and (max-width: 767px) {
    .contentPost {
        margin-bottom: 80px;
        height: 300px;
    }

    .vs-input--label {
        margin-top: 20px;
    }

    .button {
        margin-top: 20px !important;
    }
}

@media (min-width: 768px) {
    .vs-input--label {
        text-align: center !important;
    }

    .contentPost {
        height: 500px;

    }

    button {
        margin-top: 30px !important;
    }
}
</style>
